module.exports = __webpack_public_path__ + "static/media/1012575.31154b1e.jpg";